import { getAxios } from "./configure-axios";
import config from "../config/vars";

let axios;

const getAxiosInstance = () => {
  if (!axios) {
    axios = getAxios();
  }
  return axios;
};

export const fetchProposal = async (kukey, record) => {
  const instance = getAxiosInstance();
  return instance.get(`${config.baseUrl}${config.paths.proposal}?kukey=${kukey}&record=${record}`);
};

export const acceptProposal = async id => {
  const instance = getAxiosInstance();
  return instance.put(`${config.baseUrl}${config.paths.proposal}?id=${id}`);
};

export const createProposal = async proposal => {
  const instance = getAxiosInstance();
  return instance.post(`${config.baseUrl}${config.paths.proposal}`, proposal);
};

export default {
  fetchProposal,
  acceptProposal,
  createProposal
};
